import { Col, Row } from 'antd';
import React, { ReactElement } from 'react';
import { GUTTOR_SPACE } from '../../../../shared/constants/commonConstants';
import DetailTimeline from '../../../crm/inPatient/newAdmission/panels/cards/DetailTimeline/DetailTimeline';
import CaseDetails from '../newAdmission/caseDetails/CaseDetails';

const DetailContent = ({ isLoading, detailForm }: any): ReactElement => {
  return (
    <div className="ml-10 mr-10">
      <Row gutter={GUTTOR_SPACE}>
        <Col md={18}>
          <CaseDetails form={detailForm} title="Reimbursement detail" isLoading={isLoading} />
        </Col>
        <Col md={6}>
          <DetailTimeline />
        </Col>
      </Row>
    </div>
  );
};
export default DetailContent;
